// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"castle-1"},"children":[{"tag":"g","attrs":{"id":"fill2"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor2","d":"M17 21H22V15H17V21Z"}},{"tag":"path","attrs":{"fill":"props.fillColor2","d":"M2 21H7V15H2V21Z"}}]},{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M17 5H7V21H17V5Z"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M22 15V21H17V15H22ZM22 15V14M2 15V21H7V15H2ZM2 15V14M12 14V21M10 8.99805H10.0039V9.00195H10V8.99805ZM14 8.99805H14.0039V9.00195H14V8.99805Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M6 3V5H7M10 3V5M10 5H14M10 5H7M14 3V5M14 5H17M18 3V5H17M7 5V21H17V5","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Castle1Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'castle-1',
    ref,
    icon: element,
  },
));

Castle1Icon.displayName = 'Castle1Icon';

export default Castle1Icon;
